import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import { parseResponse } from 'src/app/core/helpers';
import { TestMethod } from 'src/app/core/module/test-method-interface';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class TestMethodService {
  constructor(
    private http: HttpClient,
    private appSettingsService: AppSettingsService
  ) {}

  getTestMethod(queryParams: any): Observable<any> {
    let params = this.appSettingsService.queryStringFormat(queryParams);

    return this.http.get('testMethod?' + params, httpOptions).pipe(
      map((resp: any) => {
        let retData: any = {
          items: [],
          totalCount: 0,
          error: ''
        };

        if (
          resp &&
          resp.data &&
          Array.isArray(resp.data.rows) &&
          resp?.error?.code <= 0
        ) {
          let rows = resp.data.rows;
          for (const item of rows) {
            let temp: TestMethod = {
              id: item.id,
              name: item.name,
              unitOfMeasure: item.unitOfMeasure,
              unitOfMeasureAbb: item.unitOfMeasure?.abbrevation,
              description: item.description
            };
            retData.items.push(temp);
          }

          retData.totalCount = resp.data.count;
        } else {
          retData.error = resp?.error?.message ? resp.error.message : '';
        }

        return retData;
      })
    );
  }

  createTestMethod(data: TestMethod): Observable<any> {
    return this.http.post('testMethod', data, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  getByTestMethodId(id: any) {
    return this.http.get('testMethod/' + id).pipe(
      map((resp: any) => {
        let TestMethod: any;
        if (resp && resp.data) {
          let data = resp.data;
          TestMethod = data;
        }
        return TestMethod;
      })
    );
  }

  updateTestMethod(id: any, data: TestMethod): Observable<any> {
    return this.http.put('testMethod/' + id, data, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  deleteTestMethod(id: any): Observable<any> {
    return this.http.delete('testMethod/' + id, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  //handle error messages
  handleError(err: any) {
    this.appSettingsService.handleError(err);
  }

  /**
   * Deletes a test method attribute.
   * @param id The ID of the attribute to be deleted.
   * @returns An Observable containing the response from the server.
   */
  deleteTestMethodAttribute(id: any): Observable<any> {
    return this.http.delete(`testMethodAttributes/${id}`, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }
}
